/**
 * The focused element, piercing shadow roots. `document.activeElement` only
 * reports the outermost host, not the control focused inside its shadow DOM.
 *
 * @returns {Element | null}
 */
export function deepActiveElement() {
  let active = document.activeElement;
  while (active?.shadowRoot?.activeElement) {
    active = active.shadowRoot.activeElement;
  }
  return active;
}
